// extracted by mini-css-extract-plugin
module.exports = {"button":"modal_button__gax68","leftButton":"modal_leftButton__Elv6d","modalDefault":"modal_modalDefault__MFMp9"};